import { render, staticRenderFns } from "./MainMenu.vue?vue&type=template&id=b798d4b8&"
import script from "./MainMenu.vue?vue&type=script&lang=js&"
export * from "./MainMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MainMenu.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/menus/MainMenu.vue
// module id = 1652
// module chunks = 1